import { IGetEnvResponse } from '../interfaces/env.interface';
import { get } from '../utils/fetch';

export const MODE_ENV_API_ERROR: string = 'env-api-error';

export const EnvApi = {
  getEnv: async (sessionId: string): Promise<IGetEnvResponse> => {
    const searchParams = new URLSearchParams(window.location.search);
    // it works dev-login only
    if (searchParams.get('mode') === MODE_ENV_API_ERROR) {
      throw new Error();
    }
    return await get('/api/env', { sessionId }, 'getEnv');
  },
};
